export default __webpack_public_path__ + "static/media/portfolio_1.535dbf59.png";